import React, {useState} from 'react';

import ChatFormContiner from './ChatFormContainer';
import CustomBottomSheet from 'components/bottomSheet';
import ViolationModal from 'modules/violationModal';
import {violationChatItems} from './constants';
import {useLocation} from 'react-router-dom';

interface ChatFormProps {
  elements: Array<ISampleCHatlist>;
  chatId?: string;
  isScrollLoading: boolean;
  refresh: () => void;
  onWatchEnd: () => void;
}
const ChatForm = ({
  elements,
  chatId,
  isScrollLoading,
  refresh,
  onWatchEnd,
}: ChatFormProps) => {
  const [isReportOpen, setIsReportOpen] = useState(false);
  const {pathname} = useLocation();
  const isFarm = pathname.includes('farm');
  return (
    <div className="w-full h-full flex flex-col justify-center relative">
      <ChatFormContiner
        isScrollLoading={isScrollLoading}
        setIsReportOpen={setIsReportOpen}
        refresh={refresh}
        elements={elements}
        isReportOpen={isReportOpen}
        chatId={chatId}
        onWatchEnd={onWatchEnd}
      />
      <CustomBottomSheet
        isOpen={isReportOpen}
        onDismiss={() => setIsReportOpen(false)}
      >
        <ViolationModal
          open={isReportOpen}
          handleClose={() => setIsReportOpen(false)}
          items={violationChatItems}
          guid={chatId ? chatId : ''}
          object_type="chat"
          isFarm={isFarm}
        />
      </CustomBottomSheet>
    </div>
  );
};

export default ChatForm;
